/**
 * @file
 * @prettier
 */

import { InitializeSurveyPages } from "./surveyPages.js";

export function InitializeSecureBorrowerSurveyGeneralSurveyPage() {
  InitializeSurveyPages();
}
